/* Qandak display-only numerals, v1.0.0. No prices, attributes or input values are changed. */
(function () {
  'use strict';
  var locale = (document.documentElement.lang || '').toLowerCase().split('-')[0];
  if ((locale !== 'fa' && locale !== 'ps') || window.QandakLocalNumerals) return;

  var digits = '\u06f0\u06f1\u06f2\u06f3\u06f4\u06f5\u06f6\u06f7\u06f8\u06f9';
  var skip = [
    'script', 'style', 'noscript', 'template', 'input', 'textarea', 'select',
    'code', 'pre', 'svg', 'math', 'iframe', 'shopify-payment-terms',
    '.shopify-payment-button', '[contenteditable]:not([contenteditable="false"])',
    '[translate="no"]', '[data-qandak-preserve-numbers]',
    'a[href^="tel:"]', 'a[href^="mailto:"]'
  ].join(',');
  // These are display containers in Maximize. Numeric form fields are always excluded above.
  var scopes = [
    '.price__container', '.main-price', '.compare-at-price', '.unit-price', '.price-label',
    '.cart-drawer__total', '.cart-drawer__saving__wrapper', '.cart-bubble__container',
    '.free-shipping__message', '[data-qandak-localize-numbers]'
  ].join(',');
  var currency = '(?:[\\u20ac\\u00a3$]|\\b(?:EUR|GBP|USD|CAD|CHF|AUD|NZD|DKK|SEK|NOK|PLN|CZK|HUF|RON|BGN|ISK|AFN)\\b)';
  var number = '[+\\-]?[0-9]+(?:[.,\\\'\\u2019\\u00a0\\u202f][0-9]+)*(?: [0-9]{3}(?![0-9]))*';
  var gap = '[\\s\\u200e\\u200f\\u061c]*';
  var prefixMoney = new RegExp('(' + currency + gap + ')(' + number + ')', 'g');
  var suffixMoney = new RegExp('(' + number + ')(' + gap + currency + ')', 'g');
  var queue = new Set();
  var scheduled = false;

  function localDigits(value) {
    return value.replace(/[0-9]/g, function (d) { return digits.charAt(Number(d)); });
  }

  function convertText(node) {
    var parent = node.parentElement;
    var before = node.nodeValue;
    if (!parent || !before || !/[0-9]/.test(before) || parent.closest(skip)) return;
    var after;
    if (parent.closest(scopes)) {
      after = localDigits(before);
    } else {
      // Outside known price areas, touch only numbers adjacent to a currency marker.
      // Thus company IDs, phone numbers, product codes and unrelated prose stay intact.
      after = before.replace(prefixMoney, function (_match, marker, amount) {
        return marker + localDigits(amount);
      }).replace(suffixMoney, function (_match, amount, marker) {
        return localDigits(amount) + marker;
      });
    }
    if (after !== before) node.nodeValue = after;
  }

  function scan(root) {
    if (!root || !root.isConnected) return;
    if (root.nodeType === 3) { convertText(root); return; }
    if (root.nodeType !== 1) return;
    if (root.closest(skip)) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) convertText(node);
  }

  function flush() {
    scheduled = false;
    var roots = Array.from(queue);
    queue.clear();
    roots.forEach(function (root, index) {
      // A parent root covers its descendants; do not rescan overlapping subtrees.
      if (roots.some(function (other, otherIndex) {
        return otherIndex !== index && other.nodeType === 1 && other.contains(root);
      })) return;
      scan(root);
    });
  }

  function enqueue(root) {
    if (!root || (root.nodeType !== 1 && root.nodeType !== 3)) return;
    queue.add(root);
    if (!scheduled) {
      scheduled = true;
      (window.requestAnimationFrame || function (fn) { return setTimeout(fn, 16); })(flush);
    }
  }

  function start() {
    if (!document.body) return;
    scan(document.body);
    if (window.MutationObserver) {
      var observer = new MutationObserver(function (records) {
        records.forEach(function (record) {
          if (record.type === 'characterData') enqueue(record.target);
          else record.addedNodes.forEach(enqueue);
        });
      });
      observer.observe(document.body, { childList: true, characterData: true, subtree: true });
    }
    document.addEventListener('shopify:section:load', function (event) { enqueue(event.target); });
  }

  window.QandakLocalNumerals = {
    version: '1.0.0',
    refresh: function () { enqueue(document.body); }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
